const localStorageUtil = {
  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  get<T>(key: string): T | null {
    const value = localStorage.getItem(key);
    try {
      return value ? JSON.parse(value) as T : null;
    } catch (error) {
      console.error(`Error parsing localStorage key "${key}"`, error);
      return null;
    }
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  },

  clear(): void {
    localStorage.clear();
  },

  has(key: string): boolean {
    return localStorage.getItem(key) !== null;
  },
};

export default localStorageUtil;